export const DEV_STUDIO_MOCK_AGENT_ID =
  "00000000-0000-4000-8000-000000000001";

export const PUBLIC_FEATURE_TIMEOUT_MS = 5000;

export const isLocalPreviewAgent = (agentId: string) =>
  agentId === DEV_STUDIO_MOCK_AGENT_ID;

export const isLocalPreviewEnabled = () =>
  import.meta.env.DEV && import.meta.env.VITE_DISABLE_LOCAL_PREVIEW !== "true";

const isAdminDesignPreview = () => {
  if (typeof window === "undefined") return false;
  if (window.self === window.top) return false;

  return new URLSearchParams(window.location.search).get("preview") === "admin-design";
};

export const shouldUseLocalAgentPreview = (agentId: string) =>
  isLocalPreviewEnabled() &&
  (isLocalPreviewAgent(agentId) || isAdminDesignPreview());

export const shouldUseLocalFeaturePreview = (agentId: string) =>
  isLocalPreviewEnabled() && isLocalPreviewAgent(agentId);

export const shouldForceLocalFeaturePreview = () =>
  isLocalPreviewEnabled() && import.meta.env.VITE_FORCE_LOCAL_PREVIEW === "true";

export const logPublicFeatureFallback = (
  featureName: string,
  agentId: string,
  error?: unknown,
) => {
  if (!import.meta.env.DEV) return;

  console.warn(
    `[PITALIy public feature] ${featureName} fallback`,
    {
      agentId,
      localPreview: shouldUseLocalFeaturePreview(agentId),
      forcedLocal: shouldForceLocalFeaturePreview(),
      error,
    },
  );
};
